import React from 'react'
import { Box } from '@mui/material'
import { GlassContainer } from '../../../../../../interaxDesignSystemComponents'
import { TeamInformationSharesLineChart } from './TeamInformationSharesLineChart'
import type { TeamInformationSharesLineChartContainerProps } from './types'
import { DEFAULT_MOCK_DATA } from './constants'
import { useTranslation } from '../../../../../../shared/hooks/useIntractionTranslate'
import { INTERAX_COLORS } from '../../../../../../constants/colors'

/**
 * Container component for Team Information Shares Line Chart
 *
 * Wraps the chart in a glassmorphism container with title
 */
export const TeamInformationSharesLineChartContainer: React.FC<TeamInformationSharesLineChartContainerProps> = ({
  data = DEFAULT_MOCK_DATA,
  title
}) => {
  const { t } = useTranslation()

  const displayTitle = title || t('facilitator.devTools.teamInformationShares.title')

  return (
    <Box
      sx={{
        width: '100%',
        padding: '16px',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'center',
        backgroundColor: INTERAX_COLORS.offBlack
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: '620px',
          height: '469px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start'
        }}
      >
        <GlassContainer
          variant="card"
          size="large"
          blur={6}
          opacity={0.08}
          borderOpacity={0.08}
          shadowIntensity={0.5}
          style={{
            width: '100%',
            height: '100%',
            padding: '24px',
            background: 'linear-gradient(144.63deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%)',
            boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.5), inset 0px 1px 0px 1px rgba(255, 255, 255, 0.1)'
          }}
        >
          <Box
            component="h1"
            className="text-headline-3"
            sx={{
              color: INTERAX_COLORS.white,
              marginBottom: '16px',
              fontWeight: 600
            }}
          >
            {displayTitle}
          </Box>
          <Box
            sx={{
              width: '100%',
              flexGrow: 1,
              position: 'relative',
              height: 0
            }}
          >
            <TeamInformationSharesLineChart data={data} height={350} />
          </Box>
        </GlassContainer>
      </Box>
    </Box>
  )
}
